import { action, observable, reaction } from 'mobx';
import { maxRecentStorage } from '../../config';
import ArrayListenerState from './abstract/ArrayListenerState';
import PropertyState from './shared/PropertyState';

const getStorageKey = (uid) => `recentProperties_${uid}`;

class RecentPropertiesState extends ArrayListenerState {
  constructor(root) {
    super(root, {
      expression: () => this.value_,
      ItemClass: PropertyState,
    });
  }

  value_ = [];

  init() {
    super.init();

    this.reactions_.push(
      reaction(
        () => this.root.userImpl,
        (userImpl) => this.handleUser_(userImpl)
      )
    );
  }

  handleUser_(userImpl) {
    if (userImpl) {
      this.storageKey = getStorageKey(userImpl.uid);
      this.readData();
    } else {
      this.storageKey = '';
      this.value_ = [];
    }
  }

  readData() {
    try {
      this.value_ = JSON.parse(localStorage.getItem(this.storageKey));
    } catch (e) {
      console.warn('Failed to read recent properties');
    }
  }

  saveData_() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.value_));
  }

  add(propertyUid) {
    const currentList = this.value_ ? [...this.value_] : [];
    const index = currentList.indexOf(propertyUid);

    if (index === -1 || index > 0) {
      // In case we need to move the item, just remove it temporary
      if (index > 0) {
        currentList.splice(index, 1);
      }

      // Add item to the first place
      currentList.unshift(propertyUid);
      this.value_ = maxRecentStorage
        ? currentList.splice(0, maxRecentStorage)
        : currentList;
      this.saveData_();
    }
  }
}

RecentPropertiesState.annotations = {
  ...ArrayListenerState.annotations,
  value_: observable.struct,
  add: action,
  readData: action,
};

export default RecentPropertiesState;
